export default "__VITE_ASSET__DLSxZkEe__"